import { render, staticRenderFns } from "./Tax.vue?vue&type=template&id=dff9171c&"
import script from "./Tax.js?vue&type=script&lang=js&"
export * from "./Tax.js?vue&type=script&lang=js&"
import style0 from "./Tax.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports